import './App.css';
import Home from './pages/Home/Home'
import Checkout from './pages/Checkout/Checkout';
import { Routes, Route } from 'react-router-dom';
import ContactPage from './pages/Contact';
import AboutPage from './pages/About/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PaymentStatus from './pages/Payment/PaymentStatus';
import PrivacyPage from './pages/Privacy/privacy';
import TermsPage from './pages/Terms/terms';

function App() {
  return (
    <div className='relative overflow-hidden'>

      <Navbar />
      <div className="App min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/more" element={<h1>More Page</h1>} />
          <Route path="/pay/:uniqueCode" element={<Checkout />} />
          <Route path="/payment-status/:internalId" element={<PaymentStatus />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default App;
